import React from "react"

import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';


import { isNull, isEqual, isArray } from "lodash";

import {hasProperty, formatText, formatDate} from '../utils/utils';
import {cloneObject, getParam, truncate} from '../utils/utils';

import D3Graphviz from "../components/D3Graphviz";


import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import ViewSolution from "../components/ViewSolution";
import ViewRole from "../components/ViewRole";
import ViewCapability from "../components/ViewCapability";
import ViewSystem from "../components/ViewSystem";
import ViewParticipation from "../components/ViewParticipation";

import Buffering from "../components/Buffering";


import { getSolutionVersion, getSolutionVersionRoles, getSolutionVersionSystems, getSolutionVersionCapabilities, getSolutionVersionParticipations  } from "../utils/utilsSolution";
import { zipSolution } from "../utils/utilsSolution";


class ViewSolutionVersion extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };


        this.handleControls = this.handleControls.bind(this);
        this.handleNavClick = this.handleNavClick.bind(this);
        this.handleExport = this.handleExport.bind(this);

        this.dsd = new dsd();
        this.dsd.StateObject = this;

    }

    componentDidMount(){

        this.setup();
 
     }

     componentDidUpdate(prevProps, prevState){

        if (!isEqual(this.props.params, prevProps.params)){
            this.setup();
        }

     }



    setup(){

        let StateChange = {
            idVersion: null,
            idSolution: null,
            type: null,
            Solution: null,
            isLoaded: false,
            isFailed: false, 
            loadData: false,

            Controls: {
            },

            xmi: null,
            dot: null,
            dotRoles: null,
            dotSystems: null,
            dotCapabilities: null,
            dotParticipations: null,

        }

        StateChange.idVersion = getParam('idVersion', this.props);
        StateChange.idSolution = getParam('idSolution', this.props);
        StateChange.isExporting = false;

        this.loadData(StateChange.idSolution, StateChange.idVersion);

        this.setState(StateChange);

    }

    loadData(id, idVersion){

        const onLoad = function(data){
            let StateChange = {};
            StateChange.Solution = data;
            StateChange.isLoaded = true;
            this.setState(StateChange);

            const onLoadXmi = (xmi) => {
                this.setState({xmi: xmi});
            };

            const onFailXmi = (e) => {
                console.error('Error fetching XMI:', e);
            };

            getSolutionVersion(
                this.dsd,
                this.state.idSolution,
                this.state.idVersion,
                onLoadXmi,
                onFailXmi,
                'xmi'
            );


            const onLoadDot = (dot) => {
                this.setState({dot: dot});
            };

            const onFailDot = (e) => {
                console.error('Error fetching DOT:', e);
            };

            getSolutionVersion(
                this.dsd,
                this.state.idSolution,
                this.state.idVersion,
                onLoadDot,
                onFailDot,
                'dot',
                null,
                {}
            );


            const onLoadRolesDot = (dots) => {
                this.setState({dotRoles: dots});
            };

            const onFailRolesDot = (e) => {
                console.error('Error fetching DOT:', e);
            };

            getSolutionVersionRoles(
                this.dsd,
                this.state.idSolution,
                this.state.idVersion,
                onLoadRolesDot,
                onFailRolesDot,
                'dot',
                null,
                {}
            );

            const onLoadSystemsDot = (dots) => {
                this.setState({dotSystems: dots});
            };

            const onFailSystemsDot = (e) => {
                console.error('Error fetching DOT:', e);
            };

            getSolutionVersionSystems(
                this.dsd,
                this.state.idSolution,
                this.state.idVersion,
                onLoadSystemsDot,
                onFailSystemsDot,
                'dot',
                null,
                {}
            );

            const onLoadCapabilitiesDot = (dots) => {
                this.setState({dotCapabilities: dots});
            };

            const onFailCapabilitiesDot = (e) => {
                console.error('Error fetching DOT:', e);
            };

            getSolutionVersionCapabilities(
                this.dsd,
                this.state.idSolution,
                this.state.idVersion,
                onLoadCapabilitiesDot,
                onFailCapabilitiesDot,
                'dot',
                null,
                {}
            );

            const onLoadParticipationsDot = (dots) => {
                this.setState({dotParticipations: dots});
            };

            const onFailParticipationsDot = (e) => {
                console.error('Error fetching DOT:', e);
            };

            getSolutionVersionParticipations(
                this.dsd,
                this.state.idSolution,
                this.state.idVersion,
                onLoadParticipationsDot,
                onFailParticipationsDot,
                'dot',
                null,
                {}
            );


            return;
        }.bind(this);

        var onFail = function(e){
            let StateChange = {};
            StateChange.Solution = null;
            StateChange.isFailed = true;

            StateChange.errorMessage = e.message;    
            if (e.response){
                if (e.response.data){
                    if (e.response.data.message){
                        StateChange.errorMessage = e.response.data.message;
                    }
                }
            }
            this.setState(StateChange);
            return;
        }.bind(this);


        if (id){
            getSolutionVersion(this.dsd, id, idVersion, onLoad, onFail);
        }

        return;
    }

    handleControls(event){

        const FormFieldName = event.target.name;
        let FormFieldValue = event.target.value;

        if (event.target.type == "checkbox"){
            FormFieldValue = event.target.checked;
        }

        let Controls = this.state.Controls;
        Controls[FormFieldName] = FormFieldValue;        
        this.setState({"Controls": Controls});

        return;

    }


    handleNavClick(event) {

        let idNode = null;

        if ("hash" in event.target){
            idNode = event.target.hash.substring(1);
        }
        else {
            
            let target = null;
            if (event.target.tagName == "a"){
                target = event.target;
            } else{
                if ("parentElement" in event.target){
                    if (event.target.parentElement.tagName == "a"){
                        target = event.target.parentElement;
                    }
                }
            }

            if (target){
                if ("href" in target){
                    idNode = target.href.baseVal;
                }
            }
        }


        if (idNode){
            const id = `${idNode}`
            const element = document.getElementById(id);
            if (element) {
              element.scrollIntoView({
                block: "start",
                behavior: "smooth",
              });
            }

        }

        event.preventDefault();

    };


    async handleExport(event){

        this.setState({isExporting: true});
        try {
            let Solution = cloneObject(this.state.Solution); 
            let idSolution = this.state.idSolution;
            let idVersion = this.state.idVersion;

            let zipData = await zipSolution(this.dsd, Solution);

            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(zipData);
            link.download = `solution_${idSolution}_version_${idVersion}.zip`;
            link.click();
        } finally {
            this.setState({isExporting: false});
        }

    }

    render() {

        if (this.state.isFailed){
            return <PD.ErrorBox>{this.state.errorMessage}</PD.ErrorBox>
        }

        if (this.state.isLoaded){
            return(
                <div>
                    <PD.Heading>{`Solution: ${this.state.Solution.name}`}</PD.Heading>
                    {this.state.Solution.Version &&
                        <>
                           {this.viewVersion(this.state.Solution.Version)}
                        </>
                    }
                    {this.viewSolution(this.state.Solution)}
                </div>
            )
        }
        return null;

    };    

    viewVersion(Version){

        if (Version){
            return(
                <fieldset>
                    <legend>Named Version</legend>
                    <PD.Table className="panel">
                        <PD.Tbody>                                

                            {hasProperty(Version,'name') &&
                                <PD.Tr>                                
                                    <PD.Th>Name</PD.Th><PD.Td>{Version.name}</PD.Td>
                                </PD.Tr>
                            }

                            {hasProperty(Version,'description') &&
                                <PD.Tr>
                                    <PD.Th>Description</PD.Th>
                                    <PD.Td>
                                        <PD.MdPresent>
                                            {Version.description}
                                        </PD.MdPresent>                                    
                                    </PD.Td>
                                </PD.Tr>
                            }

                            {hasProperty(Version,'createdAt') &&
                                <PD.Tr>
                                    <PD.Th>Date/Time</PD.Th><PD.Td>{formatDate(Version.createdAt,'dmy hms')}</PD.Td>
                                </PD.Tr>
                            }

                        </PD.Tbody>
                    </PD.Table>
                    <PD.Button onClick={this.handleExport} name="btnExport" value={this.state.isExporting ? "" : "export"}>
                        {this.state.isExporting && <Buffering/>}
                    </PD.Button>
                </fieldset>
                
            )
        };
        return null;
    };

    viewSolution(Solution){
        if (Solution){

            let countRoles = 0;
            if (Solution.Roles){
                if (Solution.Roles.length){
                    countRoles = Solution.Roles.length;
                }
            }
            let countSystems = 0;
            if (Solution.Systems){
                if (Solution.Systems.length){
                    countSystems = Solution.Systems.length;
                }
            }
            let countCapabilities = 0;
            if (Solution.Capabilities){
                if (Solution.Capabilities.length){
                    countCapabilities = Solution.Capabilities.length;
                }
            }
            let countParticipations = 0;
            if (Solution.Participations){
                if (Solution.Participations.length){
                    countParticipations = Solution.Participations.length;
                }
            }

            const images = this.dsd.getSolutionImages();

            return(
                <div>
                    <ViewSolution Solution={Solution} noLinks/>

                    <fieldset>
                        <legend>visualisation</legend>
                        <D3Graphviz dot={this.state.dot} images={images} onClick={this.handleNavClick}/>
                    </fieldset>

                    <PD.Heading level="2">Index</PD.Heading>
                    {countRoles &&
                        <fieldset>
                            <legend>Roles</legend>
                            <PD.Table className="list">
                                <PD.Thead>
                                    <PD.Tr>
                                        <PD.Th>Name</PD.Th>
                                        <PD.Th>Description</PD.Th>
                                    </PD.Tr>
                                </PD.Thead>
                                <PD.Tbody>
                                    {
                                        Solution.Roles.map(
                                            (Role, pos) => 
                                            {
                                                switch (Role.status){
                                                    case 'deprecated': return null;
                                                    default:
                                                        return (

                                                            <PD.Tr key={pos}>
                                                                <PD.Td>
                                                                    <PD.PdNavLink to={`#role_${Role._id}`} onClick={this.handleNavClick}>{Role.name}</PD.PdNavLink>
                                                                </PD.Td>
                                                                <PD.Td>
                                                                    <PD.MdPresent>{truncate(Role.description, 400)}</PD.MdPresent>
                                                                </PD.Td>
                                                            </PD.Tr>

                                                        )
                                                }
                                            }
                                    
                                        )
                                    }
                                </PD.Tbody>
                            </PD.Table>
                        </fieldset>
                    }

                    {countSystems &&
                        <fieldset>
                            <legend>Systems</legend>
                            <PD.Table className="list">
                                <PD.Thead>
                                    <PD.Tr>
                                        <PD.Th>Name</PD.Th>
                                        <PD.Th>Description</PD.Th>
                                    </PD.Tr>
                                </PD.Thead>
                                <PD.Tbody>
                                    {
                                        Solution.Systems.map(
                                            (System, pos) => 
                                            {
                                                switch (System.status){
                                                    case 'deprecated': return null;
                                                    default:
                                                        return (

                                                            <PD.Tr key={pos}>
                                                                <PD.Td>
                                                                    <PD.PdNavLink to={`#system_${System._id}`} onClick={this.handleNavClick}>{System.name}</PD.PdNavLink>
                                                                </PD.Td>
                                                                <PD.Td>
                                                                    <PD.MdPresent>{truncate(System.description, 400)}</PD.MdPresent>
                                                                </PD.Td>
                                                            </PD.Tr>

                                                        )
                                                }
                                            }
                                    
                                        )
                                    }
                                </PD.Tbody>
                            </PD.Table>
                        </fieldset>
                    }

                    {countCapabilities &&
                        <fieldset>
                            <legend>Capabilities</legend>
                            <PD.Table className="list">
                                <PD.Thead>
                                    <PD.Tr>
                                        <PD.Th>Name</PD.Th>
                                        <PD.Th>Description</PD.Th>
                                    </PD.Tr>
                                </PD.Thead>
                                <PD.Tbody>
                                    {
                                        Solution.Capabilities.map(
                                            (Capability, pos) => 
                                            {
                                                switch (Capability.status){
                                                    case 'deprecated': return null;
                                                    default:
                                                        return (

                                                            <PD.Tr key={pos}>
                                                                <PD.Td>
                                                                    <PD.PdNavLink to={`#capability_${Capability._id}`} onClick={this.handleNavClick}>{Capability.name}</PD.PdNavLink>
                                                                </PD.Td>
                                                                <PD.Td>
                                                                    <PD.MdPresent>{truncate(Capability.description, 400)}</PD.MdPresent>
                                                                </PD.Td>
                                                            </PD.Tr>

                                                        )
                                                }
                                            }
                                    
                                        )
                                    }
                                </PD.Tbody>
                            </PD.Table>
                        </fieldset>
                    }


                    {countParticipations &&
                        <fieldset>
                            <legend>Participations</legend>
                            <PD.Table className="list">
                                <PD.Thead>
                                    <PD.Tr>
                                        <PD.Th>Name</PD.Th>
                                        <PD.Th>Description</PD.Th>
                                    </PD.Tr>
                                </PD.Thead>
                                <PD.Tbody>
                                    {
                                        Solution.Participations.map(
                                            (Participation, pos) => 
                                            {
                                                switch (Participation.status){
                                                    case 'deprecated': return null;
                                                    default:
                                                        return (

                                                            <PD.Tr key={pos}>
                                                                <PD.Td>
                                                                    <PD.PdNavLink to={`#participation_${Participation._id}`} onClick={this.handleNavClick}>{Participation.name}</PD.PdNavLink>
                                                                </PD.Td>
                                                                <PD.Td>
                                                                    <PD.MdPresent>{truncate(Participation.description, 400)}</PD.MdPresent>
                                                                </PD.Td>
                                                            </PD.Tr>

                                                        )
                                                }
                                            }
                                    
                                        )
                                    }
                                </PD.Tbody>
                            </PD.Table>
                        </fieldset>
                    }


                    <fieldset>
                        <legend>Renditions</legend>
                        <PD.Table className="list">
                            <PD.Thead>
                                <PD.Tr>
                                    <PD.Th>Type</PD.Th>
                                    <PD.Th>Description</PD.Th>
                                </PD.Tr>
                            </PD.Thead>
                            <PD.Tbody>
                                <PD.Tr>
                                    <PD.Td>
                                        <PD.PdNavLink to={`#rendition_xmi`} onClick={this.handleNavClick}>XMI</PD.PdNavLink>
                                    </PD.Td>
                                    <PD.Td>
                                    </PD.Td>
                                </PD.Tr>
                                <PD.Tr>
                                    <PD.Td>
                                        <PD.PdNavLink to={`#rendition_dot`} onClick={this.handleNavClick}>DOT</PD.PdNavLink>
                                    </PD.Td>
                                    <PD.Td>
                                    </PD.Td>
                                </PD.Tr>

                            </PD.Tbody>
                        </PD.Table>
                    </fieldset>


                    {
                        countRoles &&
                            <div>
                                <PD.Heading level="2">Roles</PD.Heading>
                                {
                                    Solution.Roles.map(
                                        (Role, pos) => 
                                        {
                                            switch (Role.status){
                                                case 'deprecated': return null;
                                                default:
                                                    return (
                                                        <fieldset key={pos} id={`role_${Role._id}`}>
                                                            <ViewRole Role={Role} noLinks/>

                                                            <fieldset>
                                                                <legend>visualisation</legend>
                                                                <D3Graphviz dot={this.state.dotRoles && this.state.dotRoles[Role._id]} images={images} onClick={this.handleNavClick}/>
                                                            </fieldset>
                                                        </fieldset>
                                                    )
                                            }
                                        }
                                    )
                                }
                            </div>
                    }

                    {
                        countSystems &&
                            <div>
                                <PD.Heading level="2">Systems</PD.Heading>
                                {
                                    Solution.Systems.map(
                                        (System, pos) => 
                                        {
                                            switch (System.status){
                                                case 'deprecated': return null;
                                                default:
                                                    return (
                                                        <fieldset key={pos} id={`system_${System._id}`}>
                                                            <ViewSystem System={System} noLinks/>

                                                            <fieldset>
                                                                <legend>visualisation</legend>
                                                                <D3Graphviz dot={this.state.dotSystems && this.state.dotSystems[System._id]} images={images} onClick={this.handleNavClick}/>
                                                            </fieldset>
                                                        </fieldset>
                                                    )
                                            }
                                        }
                                    )
                                }
                            </div>
                    }

                    {
                        countCapabilities &&
                            <div>
                                <PD.Heading level="2">Capabilities</PD.Heading>
                                {
                                    Solution.Capabilities.map(
                                        (Capability, pos) => 
                                        {
                                            switch (Capability.status){
                                                case 'deprecated': return null;
                                                default:
                                                    return (
                                                        <fieldset key={pos} id={`capability_${Capability._id}`}>
                                                            <ViewCapability Capability={Capability} noLinks/>

                                                            <fieldset>
                                                                <legend>visualisation</legend>
                                                                <D3Graphviz dot={this.state.dotCapabilities && this.state.dotCapabilities[Capability._id]} images={images} onClick={this.handleNavClick}/>
                                                            </fieldset>
                                                        </fieldset>
                                                    )
                                            }
                                        }
                                    )
                                }
                            </div>
                    }

                    {
                        countParticipations &&
                            <div>
                                <PD.Heading level="2">Participations</PD.Heading>
                                {
                                    Solution.Participations.map(
                                        (Participation, pos) => 
                                        {
                                            switch (Participation.status){
                                                case 'deprecated': return null;
                                                default:
                                                    return (
                                                        <fieldset key={pos} id={`participation_${Participation._id}`}>
                                                            <ViewParticipation Participation={Participation} noLinks/>

                                                            <fieldset>
                                                                <legend>visualisation</legend>
                                                                <D3Graphviz dot={this.state.dotParticipations && this.state.dotParticipations[Participation._id]} images={images} onClick={this.handleNavClick}/>
                                                            </fieldset>
                                                        </fieldset>
                                                    )
                                            }
                                        }
                                    )
                                }
                            </div>
                    }



                    <PD.Heading level="2">Renditions</PD.Heading>
                    {this.viewXMI(this.state.xmi)}
                    {this.viewDOT(this.state.dot)}
                </div>
            )
        }
    }

    viewXMI(xmi){

        return(
            <fieldset id={`rendition_xmi`}>
                <legend>XMI</legend>
                <pre>
                    {xmi}   
                </pre>
            </fieldset>
        )
    }

    viewDOT(dot){

        return(
            <fieldset id={`rendition_dot`}>
                <legend>DOT</legend>
                <pre>
                    {dot}   
                </pre>
            </fieldset>
        )
    }
 
};

 
export default function ViewSolutionVersion_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ViewSolutionVersion {...props} navigation={navigation} location={location} params={params} />;
  }
